<template>
  <div>
    <div class="page-content">
      <div class="container-fluid" style="min-height: 80vh; margin-top: 2rem;">
        <div class="main-container">
          <b-card class="col-md-12" bg-variant="light" text-variant="dark">
            <div class="row">
              <div class="col-md-6">
                <div
                  class="widget widget-controls widget-table widget-notifications"
                >
                  <div
                    class="widget-controls__header widget-controls__header--bordered"
                  >
                    <!-- <div class="input-group input-group-icon icon-left" style="margin-bottom: 0rem;"> -->
                    <!-- <autocomplete
                      :suggestions="getUsers"
                      placeholder="Search user..."
                      :keys="searchKey"
                      :display="displayKey"
                      :onSelected="onSelected"
                      :value="selectedName"
                      v-model="selection"
                      style="width: 100%;">
                    </autocomplete> -->
                    <!-- <input class="form-control form-control-lg" placeholder="Search user" type="email" @keyup.enter="findUser"> -->
                    <!-- <span class="input-icon fa fa-search" ></span>
                  </div> -->
                    <div>
                      User Details
                    </div>
                  </div>
                  <div
                    class="widget-controls__content js-scrollable"
                    data-simplebar="init"
                    style="justify-content: center;color: rgba(0,0,0,0.28); align-items: center;"
                  >
                    <span
                      class="fa fa-user"
                      style="font-size: 8em; color: rgba(0,0,0,0.28)"
                    ></span>
                    <h2 style="font-weight:700" v-show="selectedUser !== null">
                      {{ selectedUser !== null ? selectedUser.firstName : "" }}
                      {{ selectedUser !== null ? selectedUser.lastName : "" }}
                    </h2>
                    <div class="card-text profile text-center">
                      <h3>
                        {{ selectedUser !== null ? selectedUser.email : "" }}
                      </h3>
                      <h3>
                        {{
                          selectedUser !== null ? selectedUser.phoneNumber : ""
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="widget widget-controls widget-table widget-notifications"
                >
                  <div
                    class="widget-controls__header widget-controls__header--bordered"
                  >
                    <div>
                      Privileges
                    </div>
                  </div>
                  <div
                    class="widget-controls__content js-scrollable"
                    data-simplebar="init"
                  >
                    <div
                      class="simplebar-track vertical"
                      style="visibility: visible;"
                    >
                      <div
                        class="simplebar-scrollbar"
                        style="top: 2px; height: 100px;"
                      ></div>
                    </div>
                    <div
                      class="simplebar-track horizontal"
                      style="visibility: hidden;"
                    >
                      <div class="simplebar-scrollbar"></div>
                    </div>
                    <div
                      class="simplebar-scroll-content"
                      style="padding-right: 14px; margin-bottom: -28px;"
                    >
                      <div
                        class="simplebar-content"
                        style="padding-bottom: 14px; margin-right: -14px; overflow-x: auto;"
                      >
                        <div class="widget-notifications__items">
                          <!-- {{roleData}} -->
                          <div class="table-responsive">
                            <table
                              class="table table-sm color-icon-label-table"
                            >
                              <tbody>
                                <tr
                                  v-for="(singleItem, index_) in roles"
                                  :key="index_"
                                >
                                  <td>{{ singleItem.name }}</td>
                                  <td>{{ singleItem.description }}</td>
                                  <td>
                                    <div
                                      v-if="
                                        (val = userRole.find(data =>
                                          data.role.id === singleItem.id
                                            ? true
                                            : false
                                        ))
                                      "
                                    >
                                      <a
                                        href="#"
                                        class="btn btn-sm btn-success"
                                        @click="
                                          alterMap(
                                            false,
                                            singleItem.id,
                                            singleItem.name,
                                            userId
                                          )
                                        "
                                        >Disable</a
                                      >
                                    </div>
                                    <div v-else>
                                      <a
                                        href="#"
                                        class="btn btn-sm btn-primary"
                                        @click="
                                          alterMap(
                                            true,
                                            singleItem.id,
                                            singleItem.name,
                                            userId
                                          )
                                        "
                                        >Enable</a
                                      >
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Autocomplete from "../../utils/Autocomplete";
import { mapGetters } from "vuex";
export default {
  components: {
    Autocomplete
  },
  data() {
    return {
      searchKey: ["first_name", "last_name"],
      displayKey: ["first_name", "last_name"],
      selectedName: "",
      selection: "",
      userId: 0,
      roles: [],
      User: {
        first_name: "",
        last_name: ""
      },
      selectedUser: null,
      roleData: "",
      userRole: []
    };
  },
  computed: {
    userDevices() {
      let devices = this.getDeviceByUserId(this.userId);
      return devices;
    },
    fullname() {
      firstname =
        this.User.first_name === undefined ? this.User.first_name : "";
      lastname = this.User.last_name === undefined ? this.User.last_name : "";
      return firstname + " " + lastname;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      const url = `/users/findOne?filter[where][id][eq]=${this.userId}`;
      HTTP.get(url)
        .then(response => {
          this.selectedUser = response.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchPrivileges() {
      const HTTP = this.$httpUtils.instance;
      const self = this;
      const url = "/roles/";
      HTTP.get(url)
        .then(response => {
          self.roleData = response.data;
          this.$store.commit("setRole", self.roleData);
          this.roles = response.data;
          console.log("roles", response.data);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchRowMap() {
      const HTTP = this.$httpUtils.instance;
      const self = this;
      const url = `/role_mappings/?filter[where][principalId]=${this.userId}&filter[include][role]`;
      HTTP.get(url)
        .then(response => {
          self.userRole = response.data;
          this.fetchUsers();
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    alterMap(type, roleId, roleName, userId) {
      const HTTP = this.$httpUtils.instance;
      const self = this;
      const url = `/role_mappings`;
      if (type) {
        HTTP.post(
          url,
          JSON.stringify({
            roleId: roleId,
            principalId: userId,
            principalType: roleName
          })
        )
          .then(response => {
            console.log(JSON.stringify(response.data));
            this.fetchRowMap();
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        HTTP.get(
          `${url}?filter[where][principalId]=${userId}&filter[where][roleId]=${roleId}`
        )
          .then(response => {
            HTTP.delete(`${url}/${response.data[0].id}`).then(res => {
              this.fetchRowMap();
            });
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    }
  },
  mounted() {
    this.userId = this.$route.params.userId * 1;
    this.fetchRowMap();
    this.fetchPrivileges();
  }
};
</script>
<style scoped>
.page-content {
  padding-top: 0.2rem;
}
.card-title {
  font-size: 1.6rem;
}
#profile_id {
  /* background-image: url(/static/img/bg.png); */
  background-size: contain;
  background-color: #5c6bc0;
  /* border-color: #5c6bc0; */
  /* color: #fff; */
}
#profile_id .card-body {
  background: #ffffff !important;
}
.card-img-top {
  max-height: 20rem;
  border-radius: 12px;
}

.profile-img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  margin-top: -230px;
}
.card-text.profile {
  text-align: left;
}
.menu_pin:hover {
  transform: scale(1.03);
}
.menu_pin {
  background-image: url(/static/img/bg.png);
  background-size: contain;
  border-radius: 7px;
  cursor: pointer;
  /* color: #ffffff; */
  background: #fff;
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  padding: 0;
  /* border: #5c6bc0 1px solid ; */
  /* height: 120px; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.btn-icon {
  font-size: 4rem;
  /* color: #5c6bc0; */
}
.detail .btn-icon {
  font-size: 1.2rem;
  color: rgb(70, 70, 70);
  margin-right: 20px;
  float: left;
}

.widget-beta__desc {
  font-size: 2rem;
}
td a {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/allow.vue